import { useLocation, useNavigate } from "react-router-dom";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import BackArrowIcon from "../../../../components/Icons/BackArrowIcon";
import EmployeeBasicDetails from "./OnBoardComponents/EmployeeBasicDetails";
import EmployeePermissions from "./OnBoardComponents/EmployeePermissions";
import EmployeeAdvanceDetails from "./OnBoardComponents/EmployeeAdvanceDetails";
import EmployeeAddressDetails from "./OnBoardComponents/EmployeeAddressDetails";
import EmployeeBankDetails from "./OnBoardComponents/EmployeeBankDetails";
import EmployeePreviousWork from "./OnBoardComponents/EmployeePreviousWork";
import EmployeeNomineeDetails from "./OnBoardComponents/EmployeeNomineeDetails";
import EmployeeDocuments from "./OnBoardComponents/EmployeeDocuments";
import EmployeeSalaryDetail from "./OnBoardComponents/EmployeeSalaryDetail";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import BgBlurLoader from "../../../../components/Loaders/BgBlurLoader";

export default function AddEmployeeOnBoard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [employeeDetail, setEmployeeDetail] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [firstFormData, setFirstFormData] = useState();
  const [pageStates, setPageStates] = useState({
    activeTab: 1,
    Id_onCreateEmp: null,
  });
  const [creationComplete, setCreationComplete] = useState(false);

  const isUpdateFlow = !!location?.state?.data;
  const currentUserId = location?.state?.data?.id || pageStates?.Id_onCreateEmp;

  useEffect(() => {
    if (currentUserId) {
      GetEmployeeDetail(currentUserId);
    } else {
      setEmployeeDetail({});
    }
  }, [currentUserId, pageStates?.activeTab]);

  const GetEmployeeDetail = (id) => {
    let options = { method: "GET" };
    let API = apiUrl?.get_profile + `?userId=${id}`;
    if (!employeeDetail || !employeeDetail.id) {
      setIsLoading(true);
    }
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setEmployeeDetail(response?.data || {});
      } else {
        toast.error(response?.message);
      }
    });
  };

  const toggleTab = (tab) => {
    if (isUpdateFlow) {
      setPageStates((prev) => ({ ...prev, activeTab: tab }));
    } else if (!creationComplete && (tab === 1 || tab === 2)) {
      setPageStates((prev) => ({ ...prev, activeTab: tab }));
    } else if (!creationComplete) {
      toast.info("Please complete the creation process before proceeding.");
    } else if (creationComplete && tab > 2) {
      setPageStates((prev) => ({ ...prev, activeTab: tab }));
    } else {
      toast.info("Basic Details and Permissions can only be updated later.");
    }
  };

  //show loader until data is ready
  if (isLoading || employeeDetail === null) {
    return (
      <>
        <BgBlurLoader />
      </>
    );
  }

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {isUpdateFlow ? "Update" : "Add"} Employee
            </h1>
          </div>
        </div>

        {/* Wizard Tabs */}
        <div className="card mb-4">
          <div className="card-body py-3">
            <div className="wizard-tabs">
              <Nav tabs className="nav nav-pills">
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 1 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(1)}
                  >
                    <h6>Step 1</h6>
                    <h5>Basic Details</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 2 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(2)}
                  >
                    <h6>Step 2</h6>
                    <h5>Permissions</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 3 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(3)}
                  >
                    <h6>Step 3</h6>
                    <h5>Advance Details</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 4 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(4)}
                  >
                    <h6>Step 4</h6>
                    <h5>Address</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 5 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(5)}
                  >
                    <h6>Step 5</h6>
                    <h5>Bank Details</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 6 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(6)}
                  >
                    <h6>Step 6</h6>
                    <h5>Nominee Details</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 7 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(7)}
                  >
                    <h6>Step 7</h6>
                    <h5>Previous Work</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 8 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(8)}
                  >
                    <h6>Step 8</h6>
                    <h5>Documents</h5>
                  </NavLink>
                </NavItem>
                <li className="nav-item">
                  <div className="border-top-item" />
                </li>
                <NavItem>
                  <NavLink
                    className={
                      pageStates?.activeTab === 9 ? "border-0 p-2 active" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleTab(9)}
                  >
                    <h6>Step 9</h6>
                    <h5>Salary Detail</h5>
                  </NavLink>
                </NavItem>
              </Nav>
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="card">
          <div className="card-body">
            <TabContent activeTab={pageStates?.activeTab}>
              <TabPane tabId={1}>
                <Fade in={pageStates?.activeTab === 1} timeout={200}>
                  <EmployeeBasicDetails
                    setFirstFormData={setFirstFormData}
                    setPageStates={setPageStates}
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    isUpdateFlow={isUpdateFlow}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={2}>
                <Fade in={pageStates?.activeTab === 2} timeout={200}>
                  <EmployeePermissions
                    firstFormData={firstFormData}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    setCreationComplete={setCreationComplete}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={3}>
                <Fade in={pageStates?.activeTab === 3} timeout={200}>
                  <EmployeeAdvanceDetails
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={4}>
                <Fade in={pageStates?.activeTab === 4} timeout={200}>
                  <EmployeeAddressDetails
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={5}>
                <Fade in={pageStates?.activeTab === 5} timeout={200}>
                  <EmployeeBankDetails
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={6}>
                <Fade in={pageStates?.activeTab === 6} timeout={200}>
                  <EmployeeNomineeDetails
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={7}>
                <Fade in={pageStates?.activeTab === 7} timeout={200}>
                  <EmployeePreviousWork
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={8}>
                <Fade in={pageStates?.activeTab === 8} timeout={200}>
                  <EmployeeDocuments
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
              <TabPane tabId={9}>
                <Fade in={pageStates?.activeTab === 9} timeout={200}>
                  <EmployeeSalaryDetail
                    locationData={currentUserId ? employeeDetail : location?.state?.data}
                    pageStatesMain={pageStates}
                    setPageStatesMain={setPageStates}
                  />
                </Fade>
              </TabPane>
            </TabContent>
          </div>
        </div>
      </div>
    </>
  );
}
